import Ledger from "@/components/Ledger";

const CATS = [
  { value: "PERFECT_ATTENDANCE", label: "Perfect Attendance Bonus" },
  { value: "NO_LATE", label: "No Late Mark Bonus" },
  { value: "COLLECTION", label: "Collection Incentive" },
  { value: "PERFORMANCE", label: "Performance Bonus" },
  { value: "REFERRAL", label: "Referral Bonus" },
  { value: "FESTIVAL", label: "Festival Bonus" },
  { value: "SPECIAL", label: "Special Reward" },
  { value: "MANAGEMENT", label: "Management Bonus" },
  { value: "CUSTOM", label: "Custom Incentive" },
];
export default function Incentives() {
  return <Ledger title="Incentives & Bonuses" endpoint="incentives" categories={CATS} />;
}
